import React, {Component} from 'react';
import { connect } from 'react-redux'
import {CardElement, CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe} from 'react-stripe-elements';
import shortid from 'shortid'

import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'
import CustomField from '../CustomField/CustomField.js'

import { 
  tryToCreateTeam,
} from '../../actions/actions.export.js';

var pf_config = require('../../pf_config.json');

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      display_name: '',
      name: '',
      cardHasIssue: true,
      idempotency_key: shortid.generate(),
      pricing: 'monthly'
    }

    this.submit = this.submit.bind(this);
    this.handleCardChange = this.handleCardChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async submit(ev) {

    if(ev) ev.preventDefault();

    let {token} = await this.props.stripe.createToken({name: this.state.name});

    this.handleSubmit(token);
  }

  handleCardChange(e){
    this.setState({
      cardHasIssue: e.error || e.empty || !e.complete // pass an issue if it's empty or has an error
    })
  }

  componentWillReceiveProps(newProps){
    const { dispatch } = this.props;

    if(newProps.team.failedToCreateTeam !== this.state.lastFail){
      this.setState({
        lastFail: newProps.team.failedToCreateTeam,
        idempotency_key: shortid.generate()
      })
    }
  }


  handleSubmit(stripe_token){
    const {user} = this.props;

    this.props.dispatch(tryToCreateTeam({
      stripe_token: stripe_token,
      display_name: this.state.display_name,
      billing_email: user.email,
      idempotency_key: this.state.idempotency_key,
      pricing: this.state.pricing
    }))
  }


  render() {
    const { team } = this.props;

    let formDisabled = !this.state.name || this.state.cardHasIssue || this.state.disabled || !this.state.display_name;

    return (
      <div className="checkout">
        <form onSubmit={(e)=>{
          e.preventDefault()
          if(!formDisabled) this.submit(e);
        }}> 
         <CustomField 
            type="text"
            name="display_name"
            placeholder="Great Architects & Assoc"
            label="Firm Name"
            value={this.state.display_name}
            description="You can change this later."
            onChange={(e) => { this.setState({display_name: e}); }}
            serverErrors={team.createTeamForm.errors.display_name}
            required={true}
            maxLength={64}
            focus
          />
          <div className="row-push-down">
            <CustomField 
              type="text"
              name="name"
              placeholder="Jane Doe"
              label="Billing Contact"
              value={this.state.name}
              maxLength={64}
              required={true}
              onChange={(e) => {this.setState({name: e}); }}
            />
            <div className="stripe-form-element-wrapper">
              <div className="stripe-form-label">Credit Card Info*</div>
              <CardElement style={{base: {fontSize: '14px', color: '#070809', '::placeholder': {color: 'rgba(0,0,0,.4)'}}}} onChange={this.handleCardChange}/>
              <div className="stripe-form-description">All payments are processed securly by <a href="https://stripe.com" target="_blank" rel="noreferrer">Stripe</a>.</div>
            </div>

          </div>


          <div className="flex-split">
            <p className="">
              Cost per {this.state.pricing  === "monthly" ? "month" : "year"}:
            </p>
            <div>
              <p className="lead"><strong>${this.state.pricing === "monthly" ? pf_config.plans.teams.price : pf_config.plans.teams.price_yearly}</strong></p>
            </div>
          </div>

          <div className="flex-split">
            <p className="">
              Pay yearly and get two months free:
            </p>
            <p className="text-large-switch">
              <Checkbox large={true} switch={true} value={this.state.pricing === "yearly"} onToggle={() => { this.setState({pricing: this.state.pricing === "monthly" ? "yearly" : "monthly"}) }}/>
            </p>
          </div>
          
          <p className="text-center text-thin-line-height p-push-down">
            <small>After 30 days your <strong><nobr>Pattycake for Firms</nobr></strong> subscription <nobr>will begin automatically</nobr> at <strong>${this.state.pricing === "monthly" ? pf_config.plans.teams.price : pf_config.plans.teams.price_yearly}/{this.state.pricing === "monthly" ? "month" : "year"}</strong>.</small>
          </p>
            
          <div>
            { 
              (team.createTeamForm.errors.card) && 
              <p className="list-item text-danger text-center">
                <i className="fas fa-exclamation-triangle"/> &nbsp;{ team.createTeamForm.errors.card }
              </p>
            }
            
            <Button
              block={true}
              submit={true}
              display={"Start 30 Day Free Trial"}
              disabled={formDisabled}
              thinking={team.tryingToCreateTeam}
              succesful={team.successfullyCreatedTeam}
              failed={team.failedToCreateTeam}
              color="success"
              size="large"/>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { team, user } = state;

  return {
    team, user
  }
}

export default connect(mapStateToProps)(injectStripe(CheckoutForm));



// WEBPACK FOOTER //
// ./src/components/CreateATeamSubscriptionCCForm/CheckoutForm.js